module.exports = __webpack_public_path__ + "static/media/cecauto@2x.7d8315d9.jpg";